import { Button, useTheme } from '@mui/material';

import FlightCard from './FlightCard';
import { BookButton } from '@shared/pages/Flights/FlightsSearch/BookButton';

import ShareIcon from '@mui/icons-material/Share';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

import SeeShareItineraryModal from './SeeShareItineraryModal';
import { sxStyled } from './styles';

const FlightSummary = ({
  element,
  activeCluster,
  flightsInUSD,
  infoFlightsSearch,
  activeRadio,
  common_title = [],
  isCustomSearch,
  passengers,
  canBuy,
  canBook,
  body,
  legsSelectUnit,
  businessTypes,
  setOpenSeeShareItineraryModal,
  seeShareItineraryModal,
  setSeeShareItineraryModal,
  handleOpenDrawer,
  CanSaleInUsd,
  validateBaggage,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const object_cluster =
    activeCluster ||
    (element?.combinations?.[0]?.next_leg_options
      ? element.combinations[0].next_leg_options?.[0]?.cluster
      : element?.combinations?.[0]?.cluster || element.cluster);

  return (
    <>
      <FlightCard
        object_cluster={object_cluster}
        flightsInUSD={flightsInUSD}
        activeRadio={activeRadio}
        common_title={common_title}
        isCustomSearch={isCustomSearch}
        passengers={passengers}
      >
        {/* Comprar */}
        <BookButton
          canBuy={!(!canBuy || (!CanSaleInUsd && flightsInUSD.isInUSD))}
          disabled={!canBuy || (!CanSaleInUsd && flightsInUSD.isInUSD)}
          businessTypes={businessTypes}
          tooltipText="compra"
          handleClick={() => {
            validateBaggage(true, activeRadio, body);
          }}
          label="Comprar"
          color="#FFFFFF"
          backgroundColor="#03C868"
          variant="buy"
          size="medium"
        />

        {/* Reservar */}
        <BookButton
          canBuy={canBook}
          disabled={!canBook}
          tooltipText="reserva"
          handleClick={() => {
            validateBaggage(false, activeRadio, body, legsSelectUnit);
          }}
          businessTypes={businessTypes}
          label="Reservar"
          color={theme.text1}
          backgroundColor={theme.primary}
          variant="reserve"
          size="medium"
        />

        {/* Compartir */}
        <Button
          onClick={() => setOpenSeeShareItineraryModal()}
          sx={{
            border: `solid 1px ${theme.tertiary} !important`,
            width: '60%',
            borderRadius: '8px',
            fontWeight: '600',
            mt: '5px',
            fontSize: '18px',
            height: '42px',
            color: theme.tertiary,
            '&:hover': {
              background: 'none',
            },
          }}
        >
          <ShareIcon sx={{ mr: 1 }} />
          Compartir
        </Button>

        {/* Alternativas */}
        {element?.hasDuplicates && (
          <Button
            sx={sxStyle.compartirButton}
            onClick={() => handleOpenDrawer(element.cluster_id)}
          >
            <MenuOpenIcon sx={{ mr: 1 }} />
            Ver otras alternativas de vuelos
          </Button>
        )}
      </FlightCard>
      {seeShareItineraryModal && (
        <SeeShareItineraryModal
          seeShareItineraryModal={seeShareItineraryModal}
          setSeeShareItineraryModal={setSeeShareItineraryModal}
          legs={body?.cluster?.legs || []}
          compositionPrice={object_cluster?.composition_price}
          infoFlightsSearch={infoFlightsSearch}
        />
      )}
    </>
  );
};

export default FlightSummary;
